<template>
  <div style="background-color: transparent;height: 90%;width: 100%;">
    <h4 style="font-family: poppins-reg;">Jumlah Tiket Perbulan</h4>
    <apexchart type="area" height="100%" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
export default {
  props: {
    parseData: {
      type: Object,
      default: () => ({
        dibuat: [],
        closed: []
      }),
    },
  },

  data() {
    return {
      series: [
        {
          name: 'Tiket Masuk',
          data: new Array(12).fill(0)
        },
        {
          name: 'Tiket Closed',
          data: new Array(12).fill(0)
        }
      ],

      chartOptions: {
        chart: {
          height: 350,
          type: 'area'
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        xaxis: {
          type: 'string',
          categories: [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
          ]
        },
        tooltip: {
          x: {
            format: 'dd/MM/yy HH:mm'
          },
        },
      },
    }
  },

  mounted() {
    this.updateChart();
  },

  watch: {
    parseData: {
      handler() {
        this.updateChart();
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    updateChart() {
      const dibuat = this.parseData?.dibuat ?? [];
      const closed = this.parseData?.closed ?? [];

      // Pastikan panjang array 12 (Jan–Des)
      const validDibuat = dibuat.length === 12 ? dibuat : new Array(12).fill(0);
      const validClosed = closed.length === 12 ? closed : new Array(12).fill(0);

      this.series = [
        {
          name: "Tiket Masuk",
          data: validDibuat
        },
        {
          name: "Tiket Closed",
          data: validClosed
        }
      ];
    },
  }
}

</script>
